function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { motion } from 'framer-motion';
import withStyles from 'isomorphic-style-loader/withStyles';
import isEqual from 'lodash/isEqual';
import map from 'lodash/map';
import Avatar from 'components/Avatar';
import Link from 'components/Link';
import intlShape from 'shapes/intlShape';
import PopulationDashboard from 'svg/population-dashboard.svg';
import MyFamily from 'svg/my-family.svg';
import MyDoctors from 'svg/my-doctors.svg';
import NotepadWithPen from 'svg/notepad-with-pen.svg';
import InviteIcon from 'svg/invite-icon.svg';
import App from 'modules/App';
import Account from 'modules/Account';
import Notifications from 'modules/Notifications';
import Patient, { FamilyList, NoFamilyMembers, SidebarSharingRequestsList } from 'modules/Patient';
import * as constants from '../../../constants';
import messages from '../../../messages';
import Sidebar from '../Sidebar';
import styles from './PatientSidebar.pcss';
class PatientSidebar extends Sidebar {
    componentDidUpdate(prevProps) {
        const { route, sharingRequests } = this.props;
        if (route.name !== prevProps.route.name) {
            this.onHideAllMenu();
        }
        if (!isEqual(prevProps.sharingRequests, sharingRequests)) {
            ReactTooltip.rebuild();
        }
    }
    onReauthorizeAccess(evt, sharingRequest) {
        evt.preventDefault();
        this.props.onReauthorizeAccess(sharingRequest);
    }
    onRevokeAccess(evt, sharingRequest) {
        evt.preventDefault();
        this.props.onRevokeAccess(sharingRequest);
    }
    get sortedSharingRequests() {
        return this.props.sharingRequests.filter((sharingRequest)=>sharingRequest.sharingStatus === 'Approved');
    }
    get enrollingSharingRequest() {
        return this.props.sharingRequests.filter((sharingRequest)=>sharingRequest.sharingStatus === 'PendingEnrolling' || sharingRequest.sharingStatus === 'Enrolling');
    }
    get firstSharingRequest() {
        if (this.sortedSharingRequests.length > 0) {
            return this.sortedSharingRequests[0];
        }
        return null;
    }
    get secondSharingRequest() {
        if (this.sortedSharingRequests.length > 1) {
            return this.sortedSharingRequests[1];
        }
        return null;
    }
    get menuItems() {
        return [
            this.renderMenuMyResults(),
            this.renderMenuMyFamily(),
            this.renderMenuInviteFamily(),
            this.renderEnrollInClinic(),
            this.renderHr(),
            this.renderMenuMySharingRequestsHeader(),
            this.renderMenuFirstSharingRequest(),
            this.renderMenuSecondSharingRequest(),
            this.renderMenuOtherSharingRequests(),
            ...map(this.enrollingSharingRequest, (sharingRequest)=>this.renderEnrollingSharingRequest(sharingRequest))
        ];
    }
    get menuItemsSelected() {
        return {
            [constants.PWD_MENU_SELECTED_OPTIONS.MY_FAMILY]: this.renderMyFamily(),
            [constants.PWD_MENU_SELECTED_OPTIONS.OTHER_SHARING_REQUESTS]: this.renderOtherSharingRequests()
        };
    }
    renderMenuSharingLink(sharingRequest) {
        if (this.props.openDropdownId !== `${constants.SIDEBAR_DROPDOWN}-${sharingRequest.sharingRequestId}`) {
            return null;
        }
        return /*#__PURE__*/ _jsx(motion.div, {
            initial: {
                width: 0
            },
            animate: {
                width: 'auto'
            },
            exit: {
                width: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            className: "dropdownMenu__container dropdownMenu__container--oposite ml-3",
            children: /*#__PURE__*/ _jsxs("ul", {
                className: "dropdownMenu__actions",
                children: [
                    /*#__PURE__*/ _jsx("li", {
                        className: "dropdownMenu__action",
                        children: /*#__PURE__*/ _jsx(Link, {
                            to: "",
                            onClick: (evt)=>this.onReauthorizeAccess(evt, sharingRequest),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, Patient.messages.labels.reauthorizeAccess))
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        className: "dropdownMenu__action",
                        children: /*#__PURE__*/ _jsx(Link, {
                            to: "",
                            onClick: (evt)=>this.onRevokeAccess(evt, sharingRequest),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, Patient.messages.labels.revokeAccess))
                        })
                    })
                ]
            })
        });
    }
    renderMenuMyResults() {
        const { route } = this.props;
        const myResultsHref = this.context.getUrl('my-results');
        const name = this.props.intl.formatMessage(messages.sidebar.buttons.myResults);
        const selected = route.name === 'my-results';
        const fullPatientIcon = /*#__PURE__*/ _jsx(PopulationDashboard, {});
        const fullPatientText = this.props.intl.formatMessage(messages.sidebar.buttons.myResults);
        return this.renderMenuButtonItems(name, [
            fullPatientIcon,
            fullPatientText
        ], undefined, selected, myResultsHref);
    }
    renderMenuMyFamily() {
        const name = this.props.intl.formatMessage(messages.sidebar.buttons.myFamily);
        const patientsIcon = /*#__PURE__*/ _jsx(MyFamily, {});
        const selected = this.isSelectedMenuItem(constants.PWD_MENU_SELECTED_OPTIONS.MY_FAMILY);
        const patientsText = /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebar.buttons.myFamily)),
                this.renderAnimatedChevron(selected)
            ]
        });
        return this.renderMenuButtonItems(name, [
            patientsIcon,
            patientsText
        ], ()=>this.onSelectMenuItem(constants.PWD_MENU_SELECTED_OPTIONS.MY_FAMILY), selected);
    }
    renderMenuInviteFamily() {
        const name = this.props.intl.formatMessage(messages.sidebar.buttons.inviteFamilyMember);
        const fullPatientIcon = /*#__PURE__*/ _jsx(InviteIcon, {});
        const fullPatientText = /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebar.buttons.inviteFamilyMember));
        return this.renderMenuButtonItems(name, [
            fullPatientIcon,
            fullPatientText
        ], ()=>{
            this.onHideAllMenu();
            this.props.onInviteFamily();
        }, this.props.openModalId === Patient.constants.INVITE_FAMILY_MEMBERS_MODAL);
    }
    renderEnrollInClinic() {
        if (this.props.isCareGiverAccount) {
            return null;
        }
        const name = this.props.intl.formatMessage(messages.sidebar.buttons.enrollInClinic);
        const icon = /*#__PURE__*/ _jsx(NotepadWithPen, {});
        return this.renderMenuButtonItems(name, [
            icon,
            name
        ], ()=>{
            this.onHideAllMenu();
            this.props.onEnrollInClinic();
        }, this.props.openModalId === Patient.constants.ENROLL_IN_CLINIC_MODAL);
    }
    renderMenuMySharingRequestsHeader() {
        if (this.props.isCareGiverAccount) {
            return null;
        }
        const name = this.props.intl.formatMessage(messages.sidebar.buttons.mySharingRequests);
        const mySharingRequestsIcon = /*#__PURE__*/ _jsx(MyDoctors, {});
        const mySharingRequestsText = /*#__PURE__*/ _jsx("span", {
            className: "sidebar__elementContentExtend--title",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebar.buttons.mySharingRequests))
        });
        return this.renderMenuButtonItems(name, [
            mySharingRequestsIcon,
            mySharingRequestsText
        ], ()=>this.onToggleMenu(), false);
    }
    renderSharingRequestIcon(sharingRequest, name) {
        const { direction } = this.props;
        const hcpName = sharingRequest.hcp ? [
            sharingRequest.hcp.firstName,
            sharingRequest.hcp.lastName
        ] : sharingRequest.clinic.name;
        const avatar = sharingRequest.hcp ? sharingRequest.hcp.avatar : sharingRequest.clinic.logo;
        return /*#__PURE__*/ _jsx("div", {
            className: "sidebar__hcpCell",
            "data-for": "sidebar",
            "data-tip": sharingRequest.clinic.name,
            "data-offset": direction === 'ltr' ? '{ \'left\': -2 }' : '{ \'right\': 0 }',
            children: /*#__PURE__*/ _jsx(motion.div, {
                className: cn('sidebar__elementContent--SR'),
                animate: constants.VARIANTS_TYPE.CLOSED,
                variants: constants.ANIMATION_PENDING_SHARING_REQUEST,
                children: /*#__PURE__*/ _jsx("div", {
                    className: cn('sidebar__avatarContainer', {
                        sidebar__clickable: !this.isOpenMenu
                    }),
                    onClick: ()=>this.onSetMenuOpen(true),
                    onKeyDown: ()=>{},
                    children: /*#__PURE__*/ _jsx(Avatar, {
                        avatarImg: avatar,
                        name: hcpName,
                        imgClassName: "sidebar__avatar",
                        className: "sidebar__avatar"
                    })
                }, `item-menu-${name}`)
            })
        }, `menu-item-${name}-1`);
    }
    renderSharingRequestText(sharingRequest, name) {
        const hcpName = sharingRequest.hcp ? `${sharingRequest.hcp.firstName} ${sharingRequest.hcp.lastName}` : sharingRequest.clinic.name;
        const clinicName = sharingRequest.hcp ? sharingRequest.clinic.name : /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, Patient.messages.labels.unassigned));
        return /*#__PURE__*/ _jsx("div", {
            className: "sidebar__hcpCell sidebar__hcpCellExtended",
            children: /*#__PURE__*/ _jsxs(motion.div, {
                className: "sidebar__elementContent sidebar__elementContentExtend sidebar__elementContent--noHover",
                animate: constants.VARIANTS_TYPE.CLOSED,
                variants: constants.ANIMATION_PENDING_SHARING_REQUEST,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "sidebar__hcpNameContainer",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "sidebar__hcpCellHcpName",
                                children: hcpName
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "sidebar__hcpCellClinicName",
                                children: clinicName
                            })
                        ]
                    }),
                    this.renderOptions(()=>this.props.onOpenDropdown(`${constants.SIDEBAR_DROPDOWN}-${sharingRequest.sharingRequestId}`), ()=>this.renderMenuSharingLink(sharingRequest))
                ]
            })
        }, `menu-item-${name}-2`);
    }
    renderSharingRequest(sharingRequest, name) {
        if (!sharingRequest || sharingRequest.sharingStatus === 'Enrolling') return null;
        const sharingRequestIcon = this.renderSharingRequestIcon(sharingRequest, name);
        const sharingRequestText = this.renderSharingRequestText(sharingRequest, name);
        return [
            sharingRequestIcon,
            sharingRequestText
        ];
    }
    renderMenuFirstSharingRequest() {
        if (this.props.isCareGiverAccount) {
            return null;
        }
        const name = 'firstSharingRequest';
        const { firstSharingRequest } = this;
        if (!firstSharingRequest) return null;
        return this.renderSharingRequest(firstSharingRequest, name);
    }
    renderMenuSecondSharingRequest() {
        if (this.props.isCareGiverAccount) {
            return null;
        }
        const name = 'secondSharingRequest';
        const { secondSharingRequest } = this;
        if (!secondSharingRequest) return null;
        return this.renderSharingRequest(secondSharingRequest, name);
    }
    renderMenuOtherSharingRequests() {
        if (this.props.isCareGiverAccount) {
            return null;
        }
        const len = this.sortedSharingRequests.length;
        if (len <= 2) return null;
        const name = this.props.intl.formatMessage(messages.sidebar.buttons.otherSharingRequests);
        const otherSharingRequestsIcon = this.renderMoreCell(len - 2);
        const selected = this.isSelectedMenuItem(constants.PWD_MENU_SELECTED_OPTIONS.OTHER_SHARING_REQUESTS);
        const otherSharingRequestsText = /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebar.buttons.otherSharingRequests)),
                this.renderAnimatedChevron(selected)
            ]
        });
        return this.renderMenuButtonItems(name, [
            otherSharingRequestsIcon,
            otherSharingRequestsText
        ], ()=>this.onSelectMenuItem(constants.PWD_MENU_SELECTED_OPTIONS.OTHER_SHARING_REQUESTS), selected);
    }
    renderEnrollingSharingRequest(sharingRequest) {
        const { direction } = this.props;
        if (!sharingRequest || sharingRequest.sharingStatus !== 'PendingEnrolling' && sharingRequest.sharingStatus !== 'Enrolling') return null;
        const { sharingRequestId, clinic } = sharingRequest;
        const name = `enrolling-${sharingRequestId}`;
        const sharingRequestIcon = /*#__PURE__*/ _jsx("div", {
            className: "sidebar__hcpCell",
            "data-for": "sidebar",
            "data-tip": sharingRequest.clinic.name,
            "data-offset": direction === 'ltr' ? '{ \'left\': -2 }' : '{ \'right\': 0 }',
            children: /*#__PURE__*/ _jsx("div", {
                className: cn('sidebar__avatarContainer', {
                    sidebar__clickable: !this.isOpenMenu
                }),
                onClick: ()=>this.onSetMenuOpen(true),
                onKeyDown: ()=>{},
                children: /*#__PURE__*/ _jsx(Avatar, {
                    avatarImg: clinic.logo,
                    name: clinic.name,
                    imgClassName: "sidebar__avatar",
                    className: "sidebar__avatar"
                })
            }, `item-menu-${name}`)
        }, `menu-item-${name}-1`);
        const infoMessage = sharingRequest.sharingStatus === 'Enrolling' ? Patient.messages.infos.requestIsPending : Patient.messages.infos.requestIsInProgress;
        const sharingRequestText = /*#__PURE__*/ _jsx("div", {
            className: "sidebar__hcpCell sidebar__hcpCellExtended",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "sidebar__hcpNameContainer",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "sidebar__hcpCellHcpName",
                        children: clinic.name
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "sidebar__hcpCellClinicName",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, infoMessage))
                    })
                ]
            })
        }, `menu-item-${name}-2`);
        return [
            sharingRequestIcon,
            sharingRequestText
        ];
    }
    renderMyFamily() {
        const name = 'myFamily';
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                this.renderSelectedMenuHeader(name),
                /*#__PURE__*/ _jsx(NoFamilyMembers, {}),
                /*#__PURE__*/ _jsx(FamilyList, {})
            ]
        });
    }
    renderOtherSharingRequests() {
        const name = 'otherSharingRequests';
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                this.renderSelectedMenuHeader(name),
                /*#__PURE__*/ _jsx(SidebarSharingRequestsList, {
                    sharingRequests: this.sortedSharingRequests.slice(2)
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.container,
            children: this.renderContent()
        });
    }
    constructor(props){
        super(props);
        if (!props.isCareGiverAccount) {
            props.onFetchSharingRequests();
        }
        props.onFetchFamilyLinks();
    }
}
_define_property(PatientSidebar, "propTypes", {
    // Explicit props
    direction: PropTypes.string,
    menuOpen: PropTypes.bool,
    selectedMenuItem: PropTypes.string,
    isCareGiverAccount: PropTypes.bool,
    // Explicit actions
    setMenuOpen: PropTypes.func,
    setSelectedMenuItem: PropTypes.func,
    // Implicit props
    route: App.shapes.route,
    openModalId: PropTypes.string,
    openDropdownId: PropTypes.string,
    lastReceivedNotification: Notifications.shapes.notification,
    sharingRequests: PropTypes.arrayOf(Patient.shapes.sharingRequest),
    isInProgress: PropTypes.bool,
    sharingRequestsRejectsInProgress: PropTypes.arrayOf(PropTypes.string),
    intl: intlShape,
    // Implicit actions
    onFetchFamilyLinks: PropTypes.func,
    onInviteFamily: PropTypes.func,
    onEnrollInClinic: PropTypes.func,
    onFetchSharingRequests: PropTypes.func,
    onReceiveInvitationFromSessionStorage: PropTypes.func,
    onReauthorizeAccess: PropTypes.func,
    onRevokeAccess: PropTypes.func,
    onOpenDropdown: PropTypes.func
});
const mapStateToProps = (state)=>({
        route: App.selectors.route(state),
        openModalId: App.selectors.modal(state),
        openDropdownId: App.selectors.dropdown(state),
        isCareGiverAccount: Account.selectors.isCareGiverAccount(state),
        lastReceivedNotification: Notifications.selectors.lastReceivedNotification(state),
        sharingRequests: Patient.selectors.sharingRequests(state),
        isInProgress: Patient.selectors.isFetchSharingRequestsInProgress(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onFetchFamilyLinks: ()=>dispatch(Patient.actions.fetchFamilyLinks()),
        onInviteFamily: ()=>dispatch(App.actions.openModal(Patient.constants.INVITE_FAMILY_MEMBERS_MODAL)),
        onEnrollInClinic: ()=>dispatch(App.actions.openModal(Patient.constants.ENROLL_IN_CLINIC_MODAL)),
        onFetchSharingRequests: ()=>dispatch(Patient.actions.fetchSharingRequests()),
        onReauthorizeAccess: (sharingRequest)=>Promise.all([
                dispatch(Patient.actions.setBeingApprovedSharingRequestId(sharingRequest.sharingRequestId)),
                dispatch(App.actions.openModal(Patient.constants.APPROVE_DATA_SHARING_MODAL))
            ]),
        onRevokeAccess: (sharingRequest)=>Promise.all([
                dispatch(App.actions.setFormContext(Patient.constants.REVOKE_ACCESS_FORM, sharingRequest)),
                dispatch(App.actions.openModal(Patient.constants.REVOKE_ACCESS_MODAL))
            ]),
        onOpenDropdown: (dropdownId)=>dispatch(App.actions.openDropdown(dropdownId))
    });
const ConnectedPatientSidebar = connect(mapStateToProps, mapDispatchToProps)(injectIntl(PatientSidebar));
export default withStyles(styles)(ConnectedPatientSidebar);
